module.exports = __webpack_public_path__ + "img/img_web01_bg1.1cb375ce.jpg";